'use client';

import {useRouter} from 'next/navigation';
import {Button} from '../primitives';

export interface DetailViewAllLinkProps {
  label: string;
  href: string;
  onClick?: () => void;
}

export function DetailViewAllLink({label, href, onClick}: DetailViewAllLinkProps) {
  const router = useRouter();
  return (
    <Button
      variant="link"
      onClick={() => {
        onClick?.();
        router.push(href);
      }}
    >
      {label}
    </Button>
  );
}

DetailViewAllLink.displayName = 'DetailViewAllLink';
